<template>
	<div class="lc">
		<div class="lt-left">
		</div>
		<div ref="cmain1" class="cmain" :style="{ width: '480px', height: '320px' }"></div>

	</div>
</template>

<script>
 
export default {
	name: 'template4.rightTop4',
	data() {
		return {
			myChart: "",
			option: "",
			TmyChart: "",
			Toption: "",
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
	methods: {
		cDrawCircle() {
			var echarts = require('echarts');
			var TmyChart = echarts.init(this.$refs.cmain1);
			let data = [
				{ value: 1500, name: '类型1', num: 25 },
				{ value: 100 },
				{ value: 1500, name: '类型2', num: 25 },
				{ value: 100, },
				{ value: 1500, name: '类型3', num: 25 },
				{ value: 100 },
				{ value: 1500, name: '类型4', num: 25 },
				{ value: 100, }

			];
			var Toption = {
				tooltip: {
					trigger: 'item'
				},
				legend: {
					// orient: 'vertical',  //文字 行 排放 默认列
					top: '24%',
					right: 80,
					icon: "circle",
					itemStyle: {
						// borderColor: '#fff', // 边框颜色
						// borderWidth: 2,      // 边框宽度
						// borderType: 'solid', // 边框类型，默认为实线，可选值有 'solid', 'dashed', 'dotted'
						// borderRadius: '50%',    // 边框圆角，只有当 borderType 为 'solid' 或 'dashed' 时生效
					},
					// itemHeight: 10,    //图例的高度  文字左边那个
					// itemWidth: 10,
					// z: 5,
					textStyle: {
						//设置文本样式
						color: "#CBD8DE",
						lineHeight: 32,
						fontWeight: '400',
						fontSize: '14',
						// padding: [0, 0, 0, 10],
						rich: {
							a: {
								padding: [0, -20, 0, 10],
								fontSize: 16,
								color: '#fff'
							},
							b: {
								padding: [0, 0, 0, 28],
								fontSize: 16,
								fontWeight: 'bold',
								FontFamily: 'SourceHanSansCN-Bold',
								color: '#fff'
							},
						}

					},         //图例的高度
					formatter: function (name) {
						// console.log("图例的高度", name);

						let arr = [
							'{a|' + name + '}',
							'{b|' + 25 + '}  ' + '%',
						]
						return arr.join("    ")
					}

				},
				graphic:
				{
					type: 'text',
					left: "19%",
					top: '50%',
					style: {
						text: '人群占比',
						fill: '#CBEAFD',
						//   fontFamily: 'PangMenZhengDao',
						fontSize: 16,
						lingHeight: 17,
					}
				},
				series: [
					{
						type: 'pie',
						center: ['25.5%', '52%'],
						radius: ['35%', '42%'],
						avoidLabelOverlap: false,
						itemStyle: {

							color: function (params) {
								let colorList = [
									['#054585', '#78dcfe'],
									['transparent', 'transparent'],
									['#166941', '#43E3A0'],
									['transparent', 'transparent'],
									['#8A8B8A ', '#D3D3D3 '],
									['transparent', 'transparent'],
									['#BF8C39', '#EAB453'],
									['transparent', 'transparent'],
								];
								let colorItem = colorList[params.dataIndex];
								return new echarts.graphic.LinearGradient(1, 0, 0, 0, //y->y2
									[
										{
											offset: 0,
											color: colorItem[0]
										},
										{
											offset: 1,
											color: colorItem[1]
										}
									],
									false
								);
							}
						},

						label: {
							normal: {
								show: false,
							},
							emphasis: {
								show: false,
							}
						},
						labelLine: {
							normal: {
								show: false
							}
						},
						data: data
					}
				]
			};
			Toption && TmyChart.setOption(Toption);
			setInterval(function () {
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000)
		},
	},
	mounted() {
		this.$nextTick(() => {

			this.cDrawCircle(); //需要刷新的数据
		});
	},
};
</script>

<style scoped lang="scss">
@font-face {
	font-family: "SourceHanSansCN-Bold";
	src: url("../../assets/fonts/SourceHanSansCN.otf");
}

.lc {
	width: 480px;
	height: 240px;
	display: flex;
	position: relative;
	padding: 10px 0;

	//  background: pink;
}

.lt-left {
	width: 213px; //+20
	height: 171px;
	margin: 32px 0 0 16px;

	box-sizing: border-box;
	background: url('../../assets/template4/control.png') no-repeat;
	background-size: 100%;

	z-index: 1;
}

.cmain {
	position: absolute;
	top: -35px;
	// left: -163px;
	z-index: 5;
}


.bt-icon {
	position: absolute;
	width: 30px;
	height: 30px;
	left: 36px;
	top: 14px;
}
</style>